import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { VetShell } from '../components/VetShell';
import { type VetMeResponse, vetApi } from '../vet_api';

export function VetHome() {
  const [me, setMe] = useState<VetMeResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    vetApi<VetMeResponse>('/api/vet/me')
      .then(setMe)
      .catch((err) => setError(err.message ?? 'Could not load pets.'));
  }, []);

  return (
    <VetShell>
      <h1 className="text-2xl font-semibold tracking-tight">Pets shared with you</h1>
      <p className="mt-1 text-sm text-zinc-600">
        Read-only access to vaccinations, incidents, and behaviour notes.
      </p>

      {error ? <p className="mt-4 text-sm text-rose-600">{error}</p> : null}

      {me && me.pets.length === 0 ? (
        <div className="mt-8 rounded-lg border border-zinc-200 bg-white p-8 text-center">
          <p className="text-zinc-600">
            No pets have been shared with you yet. Once a pet owner invites you from their kennel
            portal, the pet will appear here.
          </p>
        </div>
      ) : null}

      {me && me.pets.length > 0 ? (
        <ul className="mt-6 divide-y divide-zinc-200 rounded-lg border border-zinc-200 bg-white">
          {me.pets.map((row) => (
            <li key={row.grantId} className="p-4 hover:bg-zinc-50">
              <Link to={`/pets/${row.pet.id}`} className="flex items-center justify-between">
                <div>
                  <p className="text-base font-medium text-zinc-900">{row.pet.name}</p>
                  <p className="mt-0.5 text-sm text-zinc-500">
                    {row.pet.species}
                    {row.pet.breed ? ` · ${row.pet.breed}` : ''}
                    {row.pet.dateOfBirth ? ` · DOB ${row.pet.dateOfBirth}` : ''}
                  </p>
                </div>
                <div className="text-right text-xs text-zinc-500">
                  <p>Last seen at</p>
                  <p className="font-medium text-zinc-700">{row.kennel.name}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </VetShell>
  );
}
